import { render, staticRenderFns } from "./ShiftForm.vue?vue&type=template&id=f77dcd18"
import script from "./ShiftForm.vue?vue&type=script&lang=js"
export * from "./ShiftForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports